<!-- 客户销售数据统计 -->
<template>
    <div class="searchAp-ctn" id="cusSaleStat">
        <div class="search-ctn" style="margin-top: 10px;" >
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">时间区间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                </div>
            </div>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            remote
                            :remote-method="searchGoodsType"
                            v-select-scroll-more="searchGoodsTypeLoad"
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" class="search-btn btn-primary" @click="calcSelected">合计</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                style="width: 100%"
                :default-sort="{ prop: 'AllAmount', order: 'descending' }"
                @sort-change="sortChange"
                :summary-method="getSummaries"
                show-summary
                @selection-change="handleSelectionChange"
                :row-key="getRowKeys"
            >
                <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150px" prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150px" prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Brand" label="品牌"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="APCate" label="分类"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="110" sortable="custom" prop="SaleTotalCount" label="销售总数"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="110" sortable="custom" prop="SaleTotalAmount" label="销售总额"></el-table-column>
                <el-table-column show-overflow-tooltip sortable="custom" min-width="100" prop="SaleTotalCost" label="总成本"></el-table-column>
                <el-table-column show-overflow-tooltip sortable="custom" min-width="100" prop="SaleTotalProfit" label="总利润"></el-table-column>
                <el-table-column label="毛利率">
                    <template slot-scope="scope">
                        {{ scope.row.SaleTotalProfit | profitPercentage(scope.row.SaleTotalAmount) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeStatisticsDialog" :visible.sync="statisticsVisible" width="500px" append-to-body>
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="saleStat"></statistics>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import statistics from '@/components/common/statistics';
export default {
    name: '',
    props: ['EntpCusId', 'StartDate', 'EndDate'],
    components: { statistics },
    data() {
        return {
            statisticsVisible: false,
            loading: false,
            searchData: {
                EntpCusId: '',
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0,
            typeList: [],
            brand: [],
            multipleSelection: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            dateTimes: [],
            // 用于汽配分类列表，分页搜索
            typeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    filters: {
        profitPercentage(val1, val2) {
            if (val1 && val2) {
                return Number((val1 / val2) * 100).toFixed(2) * 1 + '%';
            } else {
                return '0%';
            }
        }
    },
    mounted() {
        if (this.StartDate) {
            this.searchData.StartDate = this.StartDate;
            this.dateTimes.push(this.StartDate);
        }
        if (this.EndDate) {
            this.searchData.EndDate = this.EndDate;
            this.dateTimes.push(this.EndDate);
        }
        this.getTableData();
        this.searchData.EntpCusId = this.EntpCusId;
        let dialogbody = document.querySelector('#cusSaleStat');
        this.$util.setEventForDialog(this, dialogbody);
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.Id;
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType(key) {
            if (![undefined].includes(key)) {
                this.typeForm.Page = 1;
                this.typeForm.stopLoad = false;
                this.typeForm.key = key;
                this.typeList = [];
            }
            if (this.typeForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.typeForm.key, this.typeForm.Page, this.typeForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.typeForm.stopLoad = data.length < this.typeForm.Limit;
                    this.typeList = [...this.typeList, ...data];

                })
                .catch(() => {
                });
        },
        // 客户名称列表，加载更多
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        resetSearch() {
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                APCate: [],
                SortProp: '',
                SortType: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 10
            };
            this.dateTimes = [];
            this.searchData.EntpCusId = this.EntpCusId;
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/CusSaleAPStatistics',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                }).finally(()=>{
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType('');
            }
        },
        indexMethod(index) {
            return index + 1 + (this.searchData.page - 1) * this.searchData.limit;
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 6) {
                    sums[index] = '合计';
                    return;
                }
                if (index > 6) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (index > 7) sums[index] = sums[index].toFixed(2);
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return sums;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        calcSelected() {
            if (this.multipleSelection.length > 0) {
                this.statisticsVisible = true;
            } else this.$util.warningMsg('请选择要合计的数据');
        },
        closeStatisticsDialog() {
            this.statisticsVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    // height: 620px;
    overflow-y: auto;

    .el-table {
        margin-bottom: 0;
    }
}
</style>
